export interface DownloadTripInfo {
  imgFormat: string;
  canvasFormat: string;
}

export const downloadTripInfoConfig: DownloadTripInfo = {
  canvasFormat: 'image/png',
  imgFormat: 'PNG'
};
